export default __webpack_public_path__ + "static/media/DanaswapTechnicalPaper.2c65d6ba.png";